import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "What happens when you push AWS credentials to GitHub",
  "description": "",
  "published": "2019-09-13T00:00:00.000Z",
  "redirect_from": ["/blog/what-happens-when-you-push-aws-credentials-to-github/swizec/9194"],
  "categories": "Back End, Technical",
  "hero": "./img/techletter.app-screenshot-1568391389847.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A couple weeks ago I was preparing for a workshop. Making life easy for students on their fun day of hacking, GraphQL, Serverless, React, and Gatsby.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1168797303253024768"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "117.04035874439462%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'468\\'%20viewBox=\\'0%200%20400%20468\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2021c-10%205-11%2018-2%2025%205%203%2012%204%2017%201%203-2%203-4-1-4-2%200-3-3-1-5l3-1c2%200%206-3%206-5%200-3-3-7-7-10-5-3-10-4-15-1m84%2061c-4%203-2%2011%203%2011l3%201%201%201v-1c-1-1-1-2%201-3%203-3%200-11-4-11l-4%202m-41%2063c-3%200-9%203-10%204l-2%201c-3%200-3%20225%200%20228%202%202%203%202%2068%202h65v-8l-1-28a1205%201205%200%200161-6h6l2%2018c3%2027%202%2024%209%2024%205%200%205%200%203-2-6-3-1-6%208-4%206%202%208%204%204%205h13a692%20692%200%200145%201h26l2-3c2-2%202-2%202-42v-40l-4-6-3-6-3-1c-4%200-6-4-4-6l2-3%202-4c3-4%203-6-2-9-7-4-12-2-13%206l-2%205c-2%202-8%204-8%203h-10l-2%203-2%203v-3l-5-8-5-9c-2-4-6-6-8-2l-3%206-2%208c0%205%200%205-2%204l-4-1-12-1h-10v-3c1-3%201-3-2-3-4%200-5-1-3-4s-2-7-6-7c-5%200-5-3-4-14%204-20%2011-32%2022-35a202%20202%200%200135-6%20220%20220%200%200144-7l8-1c4%200%205-1%205-3%201-4%200-7-1-7a3689%203689%200%2000-113%2019v-1l98-19%2016-3v-8l-21%205a16738%2016738%200%2001-105%2022%201227%201227%200%2001-130-24h3l37%207a11675%2011675%200%200181%2013l11%201%2019-4a5954%205954%200%2001105-22v-2l-1-3a3213%203213%200%2000-124%2028c-2-2%200-2%20100-26l25-6v-6c0-11%2014-10-125-10a389962%20389962%200%2000-147%202v3h-2l-5%201c-1%203-3%202-4%200l-1-2-2-1%201-2c2-1%202-1-3-1a1241%201241%200%2001-12%200m37%2023c0%202%206%203%2039%209%2034%206%2037%207%2037%205s-2-2-38-9l-38-5m90%2016c0%202%201%203%2020%206%2013%202%2018%203%2019%202%202-2%200-3-18-6l-21-2m-84%2025c-3%208-3%209%201%2012l5%203%201%202-1%202-5%204-6%207-7%208c-2%204-5%2010-8%2012l-5%207-1%203c-1%201%202%201%2013%201%2014%200%2014-1%2015-2%201-6%201-7%204-8%204-1%207%200%208%202s2%202%2010%202h9v-19l-1-20-13-2c-10-1-13-2-13-3l4-1a1416%201416%200%200055%206l-1%2015v14l4%202c2%201%205%203%205%205%201%202%202%202%204%202l1%201-1%201-2%201%204%201h5l-1-4c-1-5%201-8%205-8s6%202%206%207v4h7l7-1%201-1%202-1h2l1%201%201-1c-2-2%200-10%202-11%204-2%206%201%206%205-1%208%203%2011%209%206l3-2v-19c0-25%200-28-4-29-4%200-4%200-5%207%200%206-1%207-3%209s-3%202-3%201l-2-6c-2-6-7-9-15-9h-20a3040%203040%200%2000-44-5l-24-4c-11-3-13-2-15%203m35%2016l-1%2020c0%2012%200%2016%201%2013l1-17v-12h3l5%201%201%2014v14h4c4%200%205-1%205-9l1-5v-1l-1-8-1-9c-2-2-16-3-18-1m-19%2045c-1%203%201%203%205%202%204%200%204%200%205%203v6l-2%201c-1%201%201%201%204%201h6l-1-7v-7h-8l-9%201m162%2011c-2%204-2%208%200%209l1%202h3c4%200%205%200%206%202%202%203%207%205%2014%207%205%200%205%200%205-2-2-4-2-5-1-5%205%202%203-6-3-13l-3-3-3%203c-4%204-9%204-11-1h-3l-2-1c-1-2-2-1-3%202m-55%206c-7%203-8%2014-1%2016h6l2-4v1c-1%205%204%2010%206%205%200-1%200-2%201-1%201%202%206%203%207%202%201-2%200-3-2-2l-1-2-4-4-2-3c1-2-4-10-6-10l-6%202m0%2030l-4%201%2011%203c15%203%2017%203%2021%200l3-2-10-2c-13-2-15-2-21%200m-111%2016l-6%202-1%203c0%203%200%204%203%206l5%203%201%201c-2%202%208%203%2011%201%201-2%201-2-1-2-3%200-4-2-1-5%201-2%202-3%203-2l5%201h2l-3-5c-2-5-4-5-18-3m62%2085l-3%201c-2%200-2%202%200%204%201%201%202%202%203%201s2%202%201%204c-1%201-2%200-4-2-2-3-3-3-3-2%200%203%204%207%207%207%202%200%207-4%205-4v-1c3-1%202-6%200-8s-4-3-6%200m50%201c-3%204-2%208%203%2011%207%203%2013-6%208-12-4-3-8-3-11%201m76-2c-8%202-6%2014%202%2014%204%200%208-4%206-5-1-1-2-2%200-3%202-2%201-4-2-5-3-2-4-2-6-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7d783377eff9ce19fb86a527cd84e350/ca0a1/techletter.app-screenshot-1568391389847.webp 223w", "/static/7d783377eff9ce19fb86a527cd84e350/75680/techletter.app-screenshot-1568391389847.webp 445w", "/static/7d783377eff9ce19fb86a527cd84e350/0ba47/techletter.app-screenshot-1568391389847.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7d783377eff9ce19fb86a527cd84e350/e92b6/techletter.app-screenshot-1568391389847.png 223w", "/static/7d783377eff9ce19fb86a527cd84e350/e66bf/techletter.app-screenshot-1568391389847.png 445w", "/static/7d783377eff9ce19fb86a527cd84e350/6af66/techletter.app-screenshot-1568391389847.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/7d783377eff9ce19fb86a527cd84e350/6af66/techletter.app-screenshot-1568391389847.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The workshop was great and then my AWS account got suspended 😅`}</p>
    <p>{`You see, a brilliant idea I had was to do file uploads. How hard can it be? A bit of JavaScript, a dash of S3, and voila you've got files on the server.`}</p>
    <p>{`Not so.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1167342901564780544"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "53.36322869955157%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'213\\'%20viewBox=\\'0%200%20400%20213\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2021c-5%203-7%208-7%2014l2%206%201%202c0%201%206%205%2010%206%203%200%205%200%208-2%206-2%206-4%202-4-3%200-4-3-1-5%201-1%203-2%204-1l1-1%202-1%201-2c0-10-14-18-23-12m-6%2045c0%206%201%207%203%207%204%200%206-1%206-6%200-6-1-7-6-7h-3v6m135%2088c-4%203-4%2011%200%2011l1%201%203%201c3%200%204%200%203-2l1-1c3%202%205-3%203-7-2-5-7-6-11-3m72%201c-5%205-2%2012%205%2012s10-7%205-12c-4-4-6-4-10%200m19-1c-3%202-3%209%200%2010h3l4%201c3-1%204-1%204-5%200-6-6-10-11-6m-70%200c-2%202-1%203%201%202v1c-2%202-3%202-4%200-2-1-2-1-2%201-3%207%207%2013%2012%206%203-3%203-7%200-5h-1c0-1%200-3-2-4-3-2-2-2-4-1m33%201c-4%203-4%206-1%206%202-1%202-1%201%202%200%204%201%204%202%200l1-3%203%203c3%204%204%203%201-1-2-3-1-3%202-2%203%202%203%202%203%200%200-6-8-9-12-5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c9e85fcf8c14266d8051c745edb90858/ca0a1/techletter.app-screenshot-1568391389646.webp 223w", "/static/c9e85fcf8c14266d8051c745edb90858/75680/techletter.app-screenshot-1568391389646.webp 445w", "/static/c9e85fcf8c14266d8051c745edb90858/0ba47/techletter.app-screenshot-1568391389646.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c9e85fcf8c14266d8051c745edb90858/e92b6/techletter.app-screenshot-1568391389646.png 223w", "/static/c9e85fcf8c14266d8051c745edb90858/e66bf/techletter.app-screenshot-1568391389646.png 445w", "/static/c9e85fcf8c14266d8051c745edb90858/6af66/techletter.app-screenshot-1568391389646.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c9e85fcf8c14266d8051c745edb90858/6af66/techletter.app-screenshot-1568391389646.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Uploading files to S3 from the browser is `}<em parentName="p">{`really hard`}</em>{`. You need an S3 bucket, that's easy, then you need a server that accepts a file from your submitted form and uploads it to S3 with the SDK and gets back the URL and ...`}</p>
    <h2 {...{
      "id": "security-by-default"
    }}>{`Security by default`}</h2>
    <p>{`You can't upload files straight to S3 from the browser because Amazon believes in security by default. `}<em parentName="p">{`Thou shalt not have an app out in the wild that is not secure.`}</em></p>
    <p>{`Great in theory, annoying when you're tight against a deadline for a toy app you intend to kill 3 days later.`}</p>
    <p>{`You can make an S3 bucket public. You can make files public too. You need an S3 access key to upload anyway.`}</p>
    <p>{`Yes even if it's a public bucket and a public file. You `}<em parentName="p">{`have to`}</em>{` upload securely.`}</p>
    <p>{`Were this not the case, anyone could upload a bunch of nefarious things to your S3 and report you to the FBI. You don't want that. 😉`}</p>
    <p>{`Uploading a file with the S3 SDK looks something like this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20AWS%20%3D%20require('aws-sdk')%3B%0A%0Aconst%20s3%20%3D%20new%20AWS.S3(%7B%0A%20%20%20%20accessKeyId%3A%20process.env.AWS_ACCESS_KEY%2C%0A%20%20%20%20secretAccessKey%3A%20process.env.AWS_SECRET_ACCESS_KEY%0A%7D)%3B%0A%0Aconst%20fileName%20%3D%20'contacts.csv'%3B%0A%0Aconst%20uploadFile%20%3D%20(data)%20%3D%3E%20%7B%0A%20%20%20%20%20const%20params%20%3D%20%7B%0A%20%20%20%20%20%20%20%20%20Bucket%3A%20'testBucket'%2C%20%2F%2F%20pass%20your%20bucket%20name%0A%20%20%20%20%20%20%20%20%20Key%3A%20'contacts.csv'%2C%20%2F%2F%20file%20will%20be%20saved%20as%20testBucket%2Fcontacts.csv%0A%20%20%20%20%20%20%20%20%20Body%3A%20JSON.stringify(data%2C%20null%2C%202)%0A%20%20%20%20%20%7D%3B%0A%20%20%20%20%20s3.upload(params%2C%20function(s3Err%2C%20data)%20%7B%0A%20%20%20%20%20%20%20%20%20if%20(s3Err)%20throw%20s3Err%0A%20%20%20%20%20%20%20%20%20console.log(%60File%20uploaded%20successfully%20at%20%24%7Bdata.Location%7D%60)%0A%20%20%20%20%20%7D)%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "726px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "72.6457399103139%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'291\\'%20viewBox=\\'0%200%20400%20291\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M19%2027l-1%20119v119h364V27l-182-1-181%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0d6f786fdd161995add37bbbc234be4b/ca0a1/techletter.app-screenshot-1568391391006.webp 223w", "/static/0d6f786fdd161995add37bbbc234be4b/75680/techletter.app-screenshot-1568391391006.webp 445w", "/static/0d6f786fdd161995add37bbbc234be4b/06b0e/techletter.app-screenshot-1568391391006.webp 726w"],
                "sizes": "(max-width: 726px) 100vw, 726px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0d6f786fdd161995add37bbbc234be4b/e92b6/techletter.app-screenshot-1568391391006.png 223w", "/static/0d6f786fdd161995add37bbbc234be4b/e66bf/techletter.app-screenshot-1568391391006.png 445w", "/static/0d6f786fdd161995add37bbbc234be4b/f8067/techletter.app-screenshot-1568391391006.png 726w"],
                "sizes": "(max-width: 726px) 100vw, 726px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/0d6f786fdd161995add37bbbc234be4b/f8067/techletter.app-screenshot-1568391391006.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Looks fine, right?`}</p>
    <p>{`Notice this part:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20s3%20%3D%20new%20AWS.S3(%7B%0A%20%20%20%20accessKeyId%3A%20process.env.AWS_ACCESS_KEY%2C%0A%20%20%20%20secretAccessKey%3A%20process.env.AWS_SECRET_ACCESS_KEY%0A%7D)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "534px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "45.2914798206278%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'181\\'%20viewBox=\\'0%200%20400%20181\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M25%2037l-1%2054c0%2051%200%2053%202%2054h348c2-1%202-3%202-54l-1-54c-2-2-348-2-350%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9e27affcdf208dc227e66eec62b3c30e/ca0a1/techletter.app-screenshot-1568391390879.webp 223w", "/static/9e27affcdf208dc227e66eec62b3c30e/75680/techletter.app-screenshot-1568391390879.webp 445w", "/static/9e27affcdf208dc227e66eec62b3c30e/29722/techletter.app-screenshot-1568391390879.webp 534w"],
                "sizes": "(max-width: 534px) 100vw, 534px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9e27affcdf208dc227e66eec62b3c30e/e92b6/techletter.app-screenshot-1568391390879.png 223w", "/static/9e27affcdf208dc227e66eec62b3c30e/e66bf/techletter.app-screenshot-1568391390879.png 445w", "/static/9e27affcdf208dc227e66eec62b3c30e/a07a7/techletter.app-screenshot-1568391390879.png 534w"],
                "sizes": "(max-width: 534px) 100vw, 534px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/9e27affcdf208dc227e66eec62b3c30e/a07a7/techletter.app-screenshot-1568391390879.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`If you send that to the browser, anyone can see your credentials and upload nefarious things.`}</p>
    <p><img parentName="p" {...{
        "src": "/64dab2c4c36ee670f5b032e42790d54c/media-YVvTCqTBglkOs-giphy.gif",
        "alt": "ugh giphy"
      }}></img></p>
    <p>{`You're supposed to run that code on a server.`}</p>
    <p>{`That keeps your credentials secure (unless your server is hacked) and means you now have to deal with file uploads in two places:`}</p>
    <ul>
      <li parentName="ul">{`browser submits file upload form to server`}</li>
      <li parentName="ul">{`server uploads file to S3`}</li>
      <li parentName="ul">{`server returns URL`}</li>
    </ul>
    <p>{`But I didn't want a server.`}</p>
    <p>{`The whole point of my workshop is that there's no servers and everything runs on AWS Lambda. Plus data transfer on AWS can get expensive.`}</p>
    <p>{`You don't want to transfer each file twice. First to your lambda, then to your S3.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/QuinnyPig/status/1172239124251709449"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "99.55156950672647%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'398\\'%20viewBox=\\'0%200%20400%20398\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M28%2023c-4%204-4%205-4%2010%200%2010%205%2015%2015%2015%2020%200%2020-29-1-29-5%200-6%200-10%204m74%200c-2%202-1%206%202%207%204%202%205%202%205%201v-3h1l4%202c3%200%203%200%203-3l-1-3c-1-1-1%200-1%201l-1%203-1-2c0-2-1-3-3-2h-1c-1-2-6-3-7-1M43%20139v1l1%203c0%203%202%202%202-1l1-2v2c0%203%202%204%202%202l1-2%201%202c0%202%207%202%207-1h1c0%203%209%202%2010%200h1c0%202%201%202%204%202l3-1%201-2c0-2%200-2-4-2-3%201-4%200-4-1h-3c-1%202-19%202-20%200h-4m0%208c-1%204%200%205%208%206%206%200%207%200%207-2h1c2%203%208%202%208%200s-1-3-3-3l-3-1h-2c-1%201-10%202-11%200h-5m73%2038v2l-2-2-2-1%201%203v2c-2%202-1%203%201%202l2-1c0%201-6%208-6%206l1-1%201-2h-2c-1%201-2%202-3%201v1l1%202h-4v2c3%202%202%205-2%205-3%200-4%200-4%202s0%203%203%203c2%200%202%201%202%205%200%207%202%205%202-2%201-6%204-15%205-14l-2%205c-1%206-3%2016-1%2016l1-5c0-6%202-13%206-18l2-4%202%203c2%204%203%204%206%201s1-6-4-5c-3%200-3%200-2-1v-2l1-3v-1h-3l-1-1%201%202m121%205l-1%203%201%202%203%205c2%203%203%203%204%202l2-3h2l-1%202v2c1%200%205-5%205-7%200-3-6-8-9-8l-6%202m-100%2027l-14%203c-7%202-8%202-9%201l-2-1%201%202v1l-1%202c1%202%201%202%205%202l7%201c1%201%201%201%200%200l-5-2c-6%200-7-2-1-3%2012-4%2022-5%2036-5%2015%201%2017%201%2016%204l2%203h6c0-3%201-3%205-1l5%202c2-1-7-5-15-7-9-2-26-3-36-2m-9%2011c-3%201-4%202-2%204l1%201-11-3h-4l2%201c2%200%200%202-3%203-2%201-2%201%200%203l2%204c-1%202%200%202%207%200h34c2%200%203%201%203%202-1%204%206%206%207%202%201-2%203-2%208%201l2-1c0-1-14-5-22-6l-6-1h10c11-1%2025-3%2029-6l-10%202c-10%202-25%203-37%202-9-1-10%200-1%201l6%201h-6l-6%201c-3%201-2-5%201-6%202-1%202-3%201-5%200-2-1-2-5%200m75%205l7%201c6%200%208%200%208%202l2%201%201%201h-3c-2-1%200%205%202%207%201%201-2%201-7%201l-9-1c0-3-10-3-11-1l-2%202a2129%202129%200%200134%200c-3%200-4-1-1-3v-3c-2-2-1-3%202-3l2-1%201-2c1-1-2-1-18-1h-8m-37%2019c-10%203-30%204-42%200l-9-2%204%202c4%201%205%202%205%204%201%203%207%205%208%202%200-2%202-2%2014-2%2013-1%2025-3%2027-5s-1-1-7%201m5%2087c-3%201-3%204%200%205%202%200%202%201%200%203-2%203%200%205%204%205s5-1%204-3c-1-1-1-1%201-1s2%200%203-3c0-6-7-10-12-6m19%200c-6%202-4%2011%202%2013%203%201%207-2%206-4%200-2%200-2%201-1%202%200%202%200%202-2%200-6-6-9-11-6m16%200c-3%204-3%207%200%2011%206%206%2017%200%2013-8-2-5-9-6-13-3m22-1c-8%203-6%2014%202%2014%205%200%209-5%205-6v-1c3%200%202-4-1-6-2-2-3-2-6-1m35%201c-3%201-5%204-3%205v2c-3%202%204%208%208%206%204-1%206-4%206-8-1-6-6-8-11-5m22-1l-1%201h-2c-2%200-2%200-1%201v4c-2%203-2%204%200%204v-2l1-1%201%203c0%201%200%202%202%201l1%201c-1%203%201%202%204%200%203-3%203-8-1-11-3-2-4-3-4-1m15%201v7c-1%200-3-1-3-3-1-1-1%200-1%202%200%205%203%208%207%207%206%200%209-6%203-6-2%200-3-2-1-4%202-1%200-4-2-4l-3%201m-149%203c-2%205%201%2010%206%2010%203%200%206-2%204-3v-4l1%202c0%202%202%203%202%200%202-3%201-4-3-4h-5c-1%202-2%201-2-1%201-2-3-3-3%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fbd7674bfca1a9bc302492b50396650b/ca0a1/techletter.app-screenshot-1568391390144.webp 223w", "/static/fbd7674bfca1a9bc302492b50396650b/75680/techletter.app-screenshot-1568391390144.webp 445w", "/static/fbd7674bfca1a9bc302492b50396650b/0ba47/techletter.app-screenshot-1568391390144.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fbd7674bfca1a9bc302492b50396650b/e92b6/techletter.app-screenshot-1568391390144.png 223w", "/static/fbd7674bfca1a9bc302492b50396650b/e66bf/techletter.app-screenshot-1568391390144.png 445w", "/static/fbd7674bfca1a9bc302492b50396650b/6af66/techletter.app-screenshot-1568391390144.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/fbd7674bfca1a9bc302492b50396650b/6af66/techletter.app-screenshot-1568391390144.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <h2 {...{
      "id": "presigned-urls--a-secure-way-to-upload"
    }}>{`Presigned URLs – a secure way to upload`}</h2>
    <p>{`AWS offers a secure solution 👉 pre-signed URLs.`}</p>
    <p>{`With a pre-signed URL, your server creates a unique URL with credentials, filenames, and other params baked in. Your browser code makes a `}<inlineCode parentName="p">{`fetch()`}</inlineCode>{` request with some data and a file shows up on your S3 bucket.`}</p>
    <p>{`You request a new pre-signed URL for the next file.`}</p>
    <p>{`I'll write more about secure S3 file uploads from the browser soon, but here's the server code in a nutshell:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=AWS.config.update(%7B%0A%20%20accessKeyId%3A%20%22%3Caccess%20key%3E%22%2C%0A%20%20secretAccessKey%3A%20%22%3Csecret%20key%3E%22%2C%0A%20%20region%3A%20process.env.S3_REGION%2C%0A%7D)%0A%0Afunction%20presignedUrl()%20%7B%0A%20%20const%20imageId%20%3D%20uuidv4()%0A%20%20const%20filename%20%3D%20%60%24%7BalbumId%7D%2F%24%7BimageId%7D%60%0A%20%20const%20expireSeconds%20%3D%2060%20*%205%0A%20%20const%20readUrl%20%3D%20%60https%3A%2F%2F%24%7Bprocess.env.S3_BUCKET%7D.s3.amazonaws.com%2F%24%7Bfilename%7D%60%0A%0A%20%20const%20uploadUrl%20%3D%20S3.getSignedUrl(%22putObject%22%2C%20%7B%0A%20%20%20%20Bucket%3A%20process.env.S3_BUCKET%2C%0A%20%20%20%20Key%3A%20filename%2C%0A%20%20%20%20ContentType%3A%20%22image%2F*%22%2C%0A%20%20%20%20Expires%3A%20expireSeconds%2C%0A%20%20%7D)%0A%0A%20%20return%20%7B%0A%20%20%20%20uploadUrl%2C%0A%20%20%20%20readUrl%2C%0A%20%20%20%20imageId%2C%0A%20%20%20%20expiresAt%3A%20addSeconds(new%20Date()%2C%20expireSeconds)%2C%0A%20%20%7D%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "750px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "84.75336322869954%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'340\\'%20viewBox=\\'0%200%20400%20340\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M18%2027a7849%207849%200%20001%20287h363l1-144V27l-183-1-182%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a5e561e299507d5725f231d035187520/ca0a1/techletter.app-screenshot-1568391390444.webp 223w", "/static/a5e561e299507d5725f231d035187520/75680/techletter.app-screenshot-1568391390444.webp 445w", "/static/a5e561e299507d5725f231d035187520/08b4d/techletter.app-screenshot-1568391390444.webp 750w"],
                "sizes": "(max-width: 750px) 100vw, 750px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a5e561e299507d5725f231d035187520/e92b6/techletter.app-screenshot-1568391390444.png 223w", "/static/a5e561e299507d5725f231d035187520/e66bf/techletter.app-screenshot-1568391390444.png 445w", "/static/a5e561e299507d5725f231d035187520/1d69c/techletter.app-screenshot-1568391390444.png 750w"],
                "sizes": "(max-width: 750px) 100vw, 750px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a5e561e299507d5725f231d035187520/1d69c/techletter.app-screenshot-1568391390444.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`You still need a server, but you can run this on a Lambda. It's a small request that's quick to calculate. A perfect fit ☺️`}</p>
    <p>{`Returns an upload URL that expires in 5 minutes with a pre-baked filename and read URL.`}</p>
    <h2 {...{
      "id": "so-how-did-swizecs-workshop-get-his-aws-account-suspended"
    }}>{`So how did Swizec's workshop get his AWS account suspended?`}</h2>
    <p>{`See this part of my code:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=AWS.config.update(%7B%0A%20%20accessKeyId%3A%20%22%3Caccess%20key%3E%22%2C%0A%20%20secretAccessKey%3A%20%22%3Csecret%20key%3E%22%2C%0A%20%20region%3A%20process.env.S3_REGION%2C%0A%7D)"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "374px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "69.05829596412556%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'277\\'%20viewBox=\\'0%200%20400%20277\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M37%2054c-2%201-3%20168-1%20171s15%203%20165%203c149%200%20162%200%20164-3s1-170-1-171c-2-3-325-3-327%200m37%2017c-3%203-2%207%202%209%206%203%2012-5%207-10-3-3-6-3-9%201m24-2c-4%201-5%207-2%209%205%205%2013-2%209-7-2-2-5-3-7-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/05e3d07a1eb9834adaa0ef9692610f69/ca0a1/techletter.app-screenshot-1568391390288.webp 223w", "/static/05e3d07a1eb9834adaa0ef9692610f69/ad40e/techletter.app-screenshot-1568391390288.webp 374w"],
                "sizes": "(max-width: 374px) 100vw, 374px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/05e3d07a1eb9834adaa0ef9692610f69/e92b6/techletter.app-screenshot-1568391390288.png 223w", "/static/05e3d07a1eb9834adaa0ef9692610f69/52dba/techletter.app-screenshot-1568391390288.png 374w"],
                "sizes": "(max-width: 374px) 100vw, 374px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/05e3d07a1eb9834adaa0ef9692610f69/52dba/techletter.app-screenshot-1568391390288.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Before I cleaned my GitHub that contained actual access keys. I knew it was bad, I knew I shouldn't, I did it anyway. Correct secrets management just felt too complicated in this case.`}</p>
    <p>{`First I created a special S3 user with access to a specific bucket. Then I copy pasted those credentials into my code and pushed away.`}</p>
    <p><img parentName="p" {...{
        "src": "/fc008eccd3e5ab702e2a025c65157b38/media-U7M0vrPBV2u5TRNazK-giphy.gif",
        "alt": "brave giphy"
      }}></img></p>
    <p>{`You might steal my credentials but it's okay. They're limited!`}</p>
    <p>{`And boy oh boy did that make the workshop `}<strong parentName="p">{`wonderful`}</strong>{`. Having access keys baked into my code `}<em parentName="p">{`made everything so easy`}</em>{`. Pull my code and get started right away.`}</p>
    <p>{`We built the whole UI before students had to even `}<em parentName="p">{`think`}</em>{` about AWS. It was fire. 🔥`}</p>
    <h2 {...{
      "id": "aws-saw-what-i-did-"
    }}>{`AWS saw what I did 😅`}</h2>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1168069016251854848"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "138.56502242152467%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'554\\'%20viewBox=\\'0%200%20400%20554\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2021c-13%208-8%2027%207%2028%208%200%2016-5%209-6-5-1-3-5%203-6%204-1%205-3%203-8-2-8-14-13-22-8m176%2086l-1%209%201%207h16v-7c0-9-1-10-8-10l-8%201m48%200c-2%200-3%201-3%202l1%208v6h13v-8l1-8h-12m41%201l-1%207v7h19v-14l-9-1-9%201m-41%207v6h9v-12h-9v6m-47%201v5h13v-10h-13v5m-33%2041c-4%204-2%209%203%209%202%200%202%200%201-1-2%200-2-1-1-1h2l2-1h2l4%202c2%200%203-1%203-3l1-3v3c0%204%202%204%202%201l1-3%201%203%201%202%201-2%201-3%201%203%201%202v-7h-12c-2-1-4%200-4%202v2l-1-1c0-5-6-7-9-4m-33%20337v3c2%205%203%206%203%202l2-4v2c-2%208-3%209-5%203-2-5-4-5-4%200%200%206%205%209%2010%207%208-4%202-17-6-13m36%201c-2%201-4%202-4%204%200%203%201%205%202%204v-1c-1-2-1-3%201-3l1%201v3c1%200%202%201%202%203l3%202c2%200%206-5%206-7%200-3-4-8-6-8l-5%202m18-1l-1%204-1%203v2l1%202%202%203c3%200%207-1%206-2l1-1c1%201%203-3%203-5%200-4-7-8-11-6m20%200c-3%200-6%205-5%208%202%208%2012%208%2013%200%201-2%200-2-2-2l-2-1-1-2v-1c2%200%203-2%201-2h-4m35%200c-1%201-2%202-1%203h-2c-3%208%205%2015%2011%209%203-3%203-7%200-11-3-2-5-2-8-1m35%201c-2%202-2%203-1%209%202%203%202%204%205%204%207%200%2010-8%206-13-3-2-8-3-10%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ca23b7d899cae81f23a78894b09b2ba7/ca0a1/techletter.app-screenshot-1568391389816.webp 223w", "/static/ca23b7d899cae81f23a78894b09b2ba7/75680/techletter.app-screenshot-1568391389816.webp 445w", "/static/ca23b7d899cae81f23a78894b09b2ba7/0ba47/techletter.app-screenshot-1568391389816.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ca23b7d899cae81f23a78894b09b2ba7/e92b6/techletter.app-screenshot-1568391389816.png 223w", "/static/ca23b7d899cae81f23a78894b09b2ba7/e66bf/techletter.app-screenshot-1568391389816.png 445w", "/static/ca23b7d899cae81f23a78894b09b2ba7/6af66/techletter.app-screenshot-1568391389816.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ca23b7d899cae81f23a78894b09b2ba7/6af66/techletter.app-screenshot-1568391389816.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`A few days before the workshop, almost as soon as I "leaked" my credentials, Amazon sent me an email.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Hey we saw your credentials got leaked. We get it, shit happens, no biggie, please fix it ... ... AND IF YOU DON'T WE WILL KILL YOUR ACCOUNT`}</p>
    </blockquote>
    <p>{`Whoa wait what? They can't be serious.`}</p>
    <p>{`So I ignored the warning and thought to myself `}<em parentName="p">{`Pfft, paranoid ops people, it's an example account. Who cares`}</em></p>
    <p>{`They kept emailing me. First every day. Then every couple hours. Like yo, you should really fix this.`}</p>
    <p>{`After the workshop I though fine fine, if you insist, I'll fix it.`}</p>
    <h3 {...{
      "id": "what-to-do-when-you-leak-aws-credentials"
    }}>{`What to do when you leak AWS credentials`}</h3>
    <p>{`Once your AWS credentials are out there, there's only one thing you can do: `}<strong parentName="p"><em parentName="strong">{`change everything`}</em></strong></p>
    <ol>
      <li parentName="ol">{`You have to change your AWS password`}</li>
      <li parentName="ol">{`You have to go into the IAM app and `}<em parentName="li">{`delete`}</em>{` all existing keys for all sub-users`}</li>
      <li parentName="ol">{`Generate new keys`}</li>
      <li parentName="ol">{`Scrub GitHub clean`}</li>
    </ol>
    <p>{`First 3 are easy. Go into your AWS console and click the things.`}</p>
    <p>{`The 4th ... how the hell do you scrub your entire GitHub history of a specific string? `}<a parentName="p" {...{
        "href": "https://rtyley.github.io/bfg-repo-cleaner/"
      }}>{`BFG`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=bash&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=bfg%20--replace-text%20passwords.txt%20.%0Agit%20push%20origin%20master%20-f%20"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "374px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.7085201793722%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'219\\'%20viewBox=\\'0%200%20400%20219\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M37%2054c-2%201-2%208-2%2057v56l2%201c4%203%20323%203%20327%200l2-1v-56c0-49%200-56-2-57-2-3-325-3-327%200m37%2017c-3%203-2%207%202%209%206%203%2012-5%207-10-3-3-6-3-9%201m24-2c-4%201-5%207-2%209%205%205%2013-2%209-7-2-2-5-3-7-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/39da2e3b3ea76cec918453a3ea144fc0/ca0a1/techletter.app-screenshot-1568391390574.webp 223w", "/static/39da2e3b3ea76cec918453a3ea144fc0/ad40e/techletter.app-screenshot-1568391390574.webp 374w"],
                "sizes": "(max-width: 374px) 100vw, 374px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/39da2e3b3ea76cec918453a3ea144fc0/e92b6/techletter.app-screenshot-1568391390574.png 223w", "/static/39da2e3b3ea76cec918453a3ea144fc0/52dba/techletter.app-screenshot-1568391390574.png 374w"],
                "sizes": "(max-width: 374px) 100vw, 374px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/39da2e3b3ea76cec918453a3ea144fc0/52dba/techletter.app-screenshot-1568391390574.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Put the strings you want to replace in `}<inlineCode parentName="p">{`passwords.txt`}</inlineCode>{` and BFG rewrites your entire history. Each password becomes a `}<inlineCode parentName="p">{`accessKeyId: "***REMOVED***",`}</inlineCode>{` ... but you can still see the diff. Lol`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/858655f72c1611b6261e9774577a3930/6a5c3/xQFcArr.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "40.35874439461883%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'161\\'%20viewBox=\\'0%200%20400%20161\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M112%2073l2%201%201%202c0%202%2040%202%2041%200l2-2%201-1-23-1-24%201m13%2011h1l1%202c0%203%2040%203%2041%200v-2c-1-2-44-1-43%200m-6%2010c-3%200-5%201-5%203a116%20116%200%200029%200l16%201%2015-1h4l2-2%201-1h-16l-7%201h-1l-4-1a2155%202155%200%2001-34%200m8%2013c0%201%200%202%201%201h1c1%202%2017%202%2017-1h1c0%202%202%203%202%200h1v1l1%201h15l5-1h1c0%202%208%201%209-1%201-4%200-4-2-1l-1%201c0-3-1-3-5-2h-14l-3%201c0%201%200%202-1%201v-1l-1-1h-2l-13-1-12%201v2m81-2h-2c-2%200-2%200-2%202%200%203%200%203%203%202h4l2-1h6l18%201h18v-3c0-2%200-2-1-1h-3l-21-1-22%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/858655f72c1611b6261e9774577a3930/ca0a1/xQFcArr.webp 223w", "/static/858655f72c1611b6261e9774577a3930/75680/xQFcArr.webp 445w", "/static/858655f72c1611b6261e9774577a3930/8d1ba/xQFcArr.webp 890w", "/static/858655f72c1611b6261e9774577a3930/3838e/xQFcArr.webp 1335w", "/static/858655f72c1611b6261e9774577a3930/83c5b/xQFcArr.webp 1646w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/858655f72c1611b6261e9774577a3930/e92b6/xQFcArr.png 223w", "/static/858655f72c1611b6261e9774577a3930/e66bf/xQFcArr.png 445w", "/static/858655f72c1611b6261e9774577a3930/4ef49/xQFcArr.png 890w", "/static/858655f72c1611b6261e9774577a3930/4e814/xQFcArr.png 1335w", "/static/858655f72c1611b6261e9774577a3930/6a5c3/xQFcArr.png 1646w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/858655f72c1611b6261e9774577a3930/4ef49/xQFcArr.png",
              "alt": "xQFcArr",
              "title": "xQFcArr",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`I guess that's part of why you also `}<em parentName="p">{`delete`}</em>{` the keys. Deactivating isn't enough Amazon says, you have to delete.`}</p>
    <h2 {...{
      "id": "you-might-still-get-banned"
    }}>{`You might still get banned`}</h2>
    <p>{`Once you've finished all the steps `}<em parentName="p">{`tell Amazon`}</em>{`. They might be omniscient in detecting that you did something bad, but they don't see that you fixed it. I don't know why.`}</p>
    <p>{`I forgot to tell them and my account got suspended.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/brihobbs/status/1169941279981146113"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "44.39461883408072%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'177\\'%20viewBox=\\'0%200%20400%20177\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M27%2026c-8%208%200%2023%2012%2023%205%200%205-1%203-4s1-4%204-2c2%203%203%202%205-2s2-5%200-5l-2-1c0-1-1-2-3-2s-4-2-2-2c1-1%201-1-1-2l-2-3c0-4-10-4-14%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/689cc679558e82a5cc157460b9df695f/ca0a1/techletter.app-screenshot-1568391389369.webp 223w", "/static/689cc679558e82a5cc157460b9df695f/75680/techletter.app-screenshot-1568391389369.webp 445w", "/static/689cc679558e82a5cc157460b9df695f/0ba47/techletter.app-screenshot-1568391389369.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/689cc679558e82a5cc157460b9df695f/e92b6/techletter.app-screenshot-1568391389369.png 223w", "/static/689cc679558e82a5cc157460b9df695f/e66bf/techletter.app-screenshot-1568391389369.png 445w", "/static/689cc679558e82a5cc157460b9df695f/6af66/techletter.app-screenshot-1568391389369.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/689cc679558e82a5cc157460b9df695f/6af66/techletter.app-screenshot-1568391389369.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`swizec.com looked like a brutalist website, techletter.app didn't work so I couldn't write newsletters, everything died. You don't know how much of your life relies on AWS until it dies.`}</p>
    <p><img parentName="p" {...{
        "src": "/587ca18d3be917e3b1ab4d30ad3fec39/media-d2lcHJTG5Tscg-giphy.gif",
        "alt": "cry giphy"
      }}></img></p>
    <p><strong parentName="p">{`Amazon support was wonderful`}</strong>{` however. A little aloof when scolding me for leaking the credentials, but absolutely wonderful once I got suspended and started crying about it on Twitter.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1170626595163430912"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "71.30044843049328%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'284\\'%20viewBox=\\'0%200%20400%20284\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M35%2019l-7%204c-3%204-3%204-3%2011l1%207%201%202c0%203%2012%207%2017%205s7-5%204-5c-4%200-5-3-2-5l3-1%203-2c7-6-6-18-17-16m27%20147v7h3c3%200%206-3%205-5v-4c0-3-1-4-4-4h-4v6m57%201c0%206%200%206%203%206%204%200%207-3%207-6%200-5-2-7-7-7h-3v7m-8%2067l-1%203%201-1c1-2%203-3%205%200v1l-1%201%202%201%201%201c0%203-2%203-2%201l-2-1-1%202v1l-2-2c0-2%200-2-2%201-2%204-1%205%205%205s9-8%204-12c-4-4-5-4-7-1m17-1c-2%201-4%207-3%209%201%203%2012%203%2013%201%202-2%200-7-2-9s-4-2-8-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3cb9f30858324316f0b1e700f8558b7c/ca0a1/techletter.app-screenshot-1568391389482.webp 223w", "/static/3cb9f30858324316f0b1e700f8558b7c/75680/techletter.app-screenshot-1568391389482.webp 445w", "/static/3cb9f30858324316f0b1e700f8558b7c/0ba47/techletter.app-screenshot-1568391389482.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3cb9f30858324316f0b1e700f8558b7c/e92b6/techletter.app-screenshot-1568391389482.png 223w", "/static/3cb9f30858324316f0b1e700f8558b7c/e66bf/techletter.app-screenshot-1568391389482.png 445w", "/static/3cb9f30858324316f0b1e700f8558b7c/6af66/techletter.app-screenshot-1568391389482.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/3cb9f30858324316f0b1e700f8558b7c/6af66/techletter.app-screenshot-1568391389482.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/AWSSupport/status/1171101468679708673"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "62.33183856502242%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'249\\'%20viewBox=\\'0%200%20400%20249\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%208c-5%202-8%207-8%2013%200%2016%2021%2021%2028%207%207-13-7-27-20-20m128%20161h-3c-4-1-7%203-7%207s0%204%204%204c3%200%203%200%203%203%200%204%201%205%203%204l1-4c0-3%200-3%204-3%203%200%203%200%203-3%200-6-6-12-8-8\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ee7258ed31c451786da813213f69e367/ca0a1/techletter.app-screenshot-1568391389892.webp 223w", "/static/ee7258ed31c451786da813213f69e367/75680/techletter.app-screenshot-1568391389892.webp 445w", "/static/ee7258ed31c451786da813213f69e367/0ba47/techletter.app-screenshot-1568391389892.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ee7258ed31c451786da813213f69e367/e92b6/techletter.app-screenshot-1568391389892.png 223w", "/static/ee7258ed31c451786da813213f69e367/e66bf/techletter.app-screenshot-1568391389892.png 445w", "/static/ee7258ed31c451786da813213f69e367/6af66/techletter.app-screenshot-1568391389892.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ee7258ed31c451786da813213f69e367/6af66/techletter.app-screenshot-1568391389892.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`What surprised me most was that `}<em parentName="p">{`I could use Support with a suspended account`}</em>{`. Can't log into AWS, can't see any of the services, but you can see support and get help.`}</p>
    <p>{`Top notch UX 👌`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>
    <p>{`PS: everything works now ^`}{`_`}{`^`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      